import React from 'react'
import { Link } from 'gatsby'

const SectionOrder = ({ link, content, heading, linkText = 'Order' }) => {
  return (
    <div
      className='lg:pt-[140px] md:pt-[88px] md:container px-[8px] pt-[65px] text-center'
      data-aos='fade-up'
      data-aos-duration='500'
      data-aos-easing='ease-in-out'
    >
      <h2 className='lg:mb-[60px] md:text-5xl text-3xl mb-[32px]'>{heading}</h2>
      <div className='lg:min-h-[290px] lg:py-[53px] md:pt-[70px] md:pb-[65px] min-h-[355px] flex flex-col justify-between items-center bg-white px-[35px] pt-[65px] pb-[40px]'>
        <p className='lg:md:max-w-[800px] md:max-w-[555px] md:text-xl text-lg'>
          {content}
        </p>
        <Link
          to={link}
          className='secondary-button px-[64px] py-[25px] mt-[24px] self-center'
        >
          {linkText}
        </Link>
      </div>
    </div>
  )
}

export default SectionOrder
